import React from 'react';
import 'leaflet/dist/leaflet.css';
import { CircleMarker, GeoJSON, MapContainer, TileLayer, useMapEvents } from 'react-leaflet';
import type { GeoJsonObject } from 'geojson';
import type { DeliveryZone } from '../../types';

type DeliveryLocationPickerProps = {
  center: { lat: number; lng: number };
  zones: DeliveryZone[];
  selectedPoint: { lat: number; lng: number } | null;
  onSelect: (coords: { lat: number; lng: number }) => void;
};

const ClickHandler: React.FC<{ onSelect: (coords: { lat: number; lng: number }) => void }> = ({ onSelect }) => {
  useMapEvents({
    click(event) {
      onSelect({
        lat: event.latlng.lat,
        lng: event.latlng.lng,
      });
    },
  });

  return null;
};

const DeliveryLocationPicker: React.FC<DeliveryLocationPickerProps> = ({
  center,
  zones,
  selectedPoint,
  onSelect,
}) => (
  <div className="overflow-hidden rounded-2xl border border-[#2A2A2A]">
    <MapContainer
      center={[center.lat || -19.9167, center.lng || -43.9345]}
      zoom={13}
      scrollWheelZoom
      className="h-[340px] w-full"
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <ClickHandler onSelect={onSelect} />
      {zones
        .filter((zone) => zone.isActive)
        .map((zone) => (
          <GeoJSON
            key={zone.id}
            data={zone.geojson as unknown as GeoJsonObject}
            style={{
              color: '#f97316',
              weight: 2,
              fillOpacity: 0.18,
            }}
          />
        ))}
      {selectedPoint && (
        <CircleMarker
          center={[selectedPoint.lat, selectedPoint.lng]}
          radius={8}
          pathOptions={{
            color: '#ffffff',
            weight: 2,
            fillColor: '#f97316',
            fillOpacity: 0.95,
          }}
        />
      )}
    </MapContainer>
  </div>
);

export default DeliveryLocationPicker;
